function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M20.172,35.369a2.444,2.444,0,0,0,0-3.457l0,0-3.79-3.775a2.455,2.455,0,0,0-3.462,0L4.744,36.31,2.131,38.918a2.443,2.443,0,0,0,0,3.452L4.455,44.7H.482a.482.482,0,0,0,0,.964H14.821a.482.482,0,0,0,0-.964H10.848L12,43.556ZM9.484,44.7H5.815l-3-3.009a1.483,1.483,0,0,1,0-2.092l2.271-2.266,5.892,5.882ZM5.766,36.652,13.6,28.817a1.484,1.484,0,0,1,2.1,0l3.79,3.78a1.484,1.484,0,0,1,0,2.1l-7.83,7.849Z",
  transform: "translate(0 -27.418)",
  fill: "#fff"
}));

var SvgErase = function SvgErase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clean",
    width: 20.888,
    height: 18.245,
    viewBox: "0 0 20.888 18.245",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/erase.c89c4c9f.svg";
export { ForwardRef as ReactComponent };